export const SET_UI_VIEW_MODE_FOCUS = "SET_UI_VIEW_MODE_FOCUS";

export const setUIViewModeFocus = (mode = true) => ({
  type: SET_UI_VIEW_MODE_FOCUS,
  mode
});



// WEBPACK FOOTER //
// ./src/actions/ui.js